export const organization = {

  list: '公司列表',
  from: '公司操作',
  view: '公司详情',
  info: '公司信息',

  logo: '公司Logo',
  keyword: '关键字查询',
  tax_code: '统一社会信用代码',
  role_id: '公司类型',
  chinese_title: '公司中文名称',
  english_title: '公司英文名称',
  shipowner_id: '关联船东',
  valid_time: '公司有效期',
  register_limit: '注册上限',
  harbor_limit: '港口上限',
  create_time: '注册时间',
  inquiry_valid_time: '询价接收有效期',
  inquiry_publish: '询价发布',
  inquiry_receive: '询价接收',
  schedule_publish: '船期发布',
  supplier_status: '企业站状态',
  law_status: '法务认证',
  no_apply: '未申请',
  no_shipowner: '无船东',
  open_finish: '已开通',
  open_shipowner: '船东开启',
  status: '数据状态',
  create_time: '加入时间',

  rules: {
    logo: {
      require: '公司Logo不能为空',
    },
    role_id: {
      require: '公司类型不能为空',
    },
    chinese_title: {
      require: '公司中文名称不能为空',
    },
    english_title: {
      require: '公司英文名称不能为空',
    },
    shipowner_id: {
      require: '关联船东不能为空',
    },
    register_limit: {
      require: '员工注册数不能为空',
    },
    valid_time: {
      require: '公司有效期不能为空',
    },
    inquiry_valid_time: {
      require: '询价有效期不能为空',
    },
    keyword: {
      require: '关键字查询不能为空',
    },
  },

  archive: {
    info: '图片信息',

    chinese_description: '公司中文简介',
    english_description: '公司英文简介',
    web_background_url: '电脑端背景图片',
    wechat_background_url: '微信端背景图片',
  },

  detail: {
    info: '详情信息',

    money: '账户余额',
    license: '营业执照',
  },

  apply: {
    info: '运力申请',

    organization_info: '申请公司信息',
    member_info: '申请人信息',

    chinese_title: '公司中文名称',
    inquiry_harbor: '申请开通港口',
    apply_status: '申请状态',
    remark: '审核意见',
    create_time: '申请时间',

    rules: {
      organization_id: {
        require: '公司中文名称不能为空',
      },
      member_id: {
        require: '申请人不能为空',
      },
      apply_status: {
        require: '申请状态不能为空',
      }
    },

    resource: {
      info: '申请资料信息',

      filename: '文件名称',
      url: '申请资料文件',
    },
  },

  audit: {
    info: '公司审核',

    title: '公司审核',
    content: '审核意见',
    business_card: '名片信息',

    rules: {
      audit_status: {
        require: '审核状态不能为空',
      }
    }
  },

  recharge: {
    from: '财务充值',
    info: '公司充值',

    money: '充值金额',
    user_info: '操作人信息',
    recharge: '充值',

    rules: {
      money: {
        require: '充值金额不能为空',
      },
    },
  },

  order: {
    list: '订单列表',
    view: '订单详情',

    order_no: '订单号',
    organization_info: '公司信息',
    order_info: '订单信息',
    money: '订单金额',
    pay_money: '支付金额',
    pay_type: '支付方式',
    pay_status: '支付状态',
    order_status: '订单状态',
    pay_time: '支付时间',
    create_time: '创建时间',

    detail: {
      money: '港口价格',
    }
  },

  contract: {
    form: '合同操作',
    info: '公司合同',

    content: '合同内容',

    rules: {
      audit_status: {
        require: '合同内容不能为空',
      }
    }
  },

  harbor: {
    form: '询价港口操作',
    info: '询价港口',

    source: '可选港口',
    target: '已选港口',
    inquiry_harbor: '待配置港口',
    harbor_code: '询价港口',
    harbor_setting: '询价港口配置',

    rules: {
      harbor_code: {
        require: '询价港口不能为空',
      }
    }
  },

  position: {
    from: '港口投放',
    info: '港口投放',

    organization_info: '公司信息',
    shipowner_info: '船东信息',
    harbor_info: '港口信息',

    harbor_code: '港口名称',
    top_position: '置顶位置',
    information_id: '绑定船期',
    is_default: '绑定类型',
    valid_time: '置顶有效期',
    start_time: '置顶开始时间',
    end_time: '置顶结束时间',
    pay_money: '支付金额',
    valid_status: '有效状态',

    rules: {
      harbor_code: {
        require: '港口名称不能为空',
      },
      top_position: {
        require: '置顶位置不能为空',
      },
      start_time: {
        require: '置顶开始时间不能为空',
      },
      end_time: {
        require: '置顶结束时间不能为空',
      },
    },

    log: {
      info: '操作日志',

      user_info: '用户信息',

      params: '请求参数',
      content: '操作内容',
      create_time: '操作时间',
    },
  },

  member: {
    from: '公司员工操作',
    info: '公司员工',

    role_id: '员工角色',
    keyword: '会员关键字',
    mobile: '手机号码',
    publisher: '发布者',
    manager: '管理员',
    supplier: '企业站',
    inquiry_mode: '询价模式',

    publish_mode: '发布模式',
    receive_mode: '接收模式',

    rules: {
      role_id: {
        require: '员工角色不能为空',
      },
      mobile: {
        require: '员工手机号码不能为空',
      },
    },

    role: {
      list: '员工角色列表',
      from: '员工角色操作',
      info: '员工角色',

      title: '员工角色标题',
      remark: '员工角色备注',
    },
  },

  log: {
    info: '公司日志',

    user_info: '用户信息',

    content: '操作内容',
    create_time: '操作时间',
  },

  role: {
    list: '角色列表',
    from: '角色操作',

    name: '角色名称',
    title: '角色标题',
    remark: '角色备注',

    rules: {
      name: {
        require: '角色名称不能为空',
      },
      title: {
        require: '角色标题不能为空',
      },
    },

    permission: {
      list: '权限列表',
      from: '权限操作',
      info: '权限',

      name: '权限名称',
      title: '权限标题',
      remark: '权限备注',
      status: '权限状态',

      rules: {
        name: {
          require: '权限名称不能为空',
        },
        title: {
          require: '权限标题不能为空',
        },
      },
    }
  },
}
